<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Nova Tributação</h4>
			<form (ngSubmit)="salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" [unmask]="true" type="text" name="cnpj" id="cnpj"
							ngModel #cnpj="ngModel"></p-inputMask>
							<div *ngIf="cnpj.hasError('required') && cnpj.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="razaoSocial">Razao Social</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" placeholder="Insira a Razão Social"
							pInputText name="razaoSocial" ngModel #razaoSocial="ngModel" required/>
							<div *ngIf="razaoSocial.hasError('required') && razaoSocial.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="nomeFantasia">Nome Fantasia</label>
							<input type="text" pInputText name="nomeFantasia" oninput="this.value = this.value.toUpperCase();"
							 ngModel #nomeFantasia="ngModel" required placeholder="Insira o Nome Fantasia"/>
							<div *ngIf="nomeFantasia.hasError('required') && nomeFantasia.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-1">
							<label htmlFor="ddd">DDD</label>
							<input type="number" pInputText name="ddd" ngModel #ddd="ngModel"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="fone">Fone</label>
							<input type="number" pInputText name="fone" ngModel #fone="ngModel"/>
						</div>
						
						<div class="field col-12 md:col-2">
							<label htmlFor="cep">CEP</label>
							<input type="text" pInputText name="cep" ngModel #cep="ngModel"/>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="logradouro">Logradouro</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="logradouro" ngModel #logradouro="ngModel" placeholder="Insira o Logradouro" />
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="numeroLogradouro">Número</label>
							<input type="number" pInputText name="numeroLogradouro" ngModel #numeroLogradouro="ngModel"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="complementoLogradouro">Complemento</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
							placeholder="Complemento"	name="complementoLogradouro" ngModel #complementoLogradouro="ngModel"/>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="bairro">Bairro</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
							placeholder="Bairro"	name="bairro" ngModel #bairro="ngModel"/>
						</div>
						
						<div class="field col-12 md:col-1">
							<label htmlFor="uf">UF</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="uf" ngModel #uf="ngModel"/>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="cidade">Cidade</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="cidade" ngModel #cidade="ngModel"/>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="crt">CRT</label>
							<p-dropdown [options]="crts" optionLabel="label" optionValue="value"
							emptyFilterMessage="Nenhum registro" placeholder="Selecione"
							name="crt" ngModel #crt="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="tipoRegistro">Tipo Registro</label>
							<p-dropdown [options]="tipoRegistros"
							placeholder="Selecione"  emptyFilterMessage="Nenhum registro"
							name="tipoRegistro" ngModel #tipoRegistro="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>

						<div class="field col-12 md:col-4" *ngIf="tipoRegistro.value === 'DANFE'">
							<label htmlFor="inscricaoEstadual">Inscrição Estadual</label>
							<input type="text" pInputText name="inscricaoEstadual" ngModel #inscricaoEstadual="ngModel"/>
						</div>
						<div class="field col-12 md:col-8" *ngIf="tipoRegistro.value === 'DANFE'">
							<label htmlFor="csc">CSC</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="csc" ngModel #csc="ngModel"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'DANFE'">
							<label htmlFor="serieNfce">Série NFCE</label>
							<input type="number" pInputText name="serieNfce" ngModel #serieNfce="ngModel"/>
						</div>

						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'DANFE'">
							<label htmlFor="ultimoNumero">Nº do Último DANFE</label>
							<input type="number" pInputText name="ultimoNumero" ngModel #ultimoNumero="ngModel"
							[(ngModel)]="ultimoDanfe"/>
						</div>

						<div class="field col-12 md:col-8" *ngIf="tipoRegistro.value === 'DANFE'">
							<label htmlFor="msgDanfe">Mensagem Danfe</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="msgDanfe" ngModel #msgDanfe="ngModel"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'DANFE'">
							<label>% IBS UF</label>
							<input type="number" pInputText
								name="pIbsUf" ngModel #pIbsUf="ngModel"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'DANFE'">
							<label>% IBS Mun</label>
							<input type="number" pInputText
								name="pIbsMun" ngModel #pIbsMun="ngModel"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'DANFE'">
							<label>% CBS</label>
							<input type="number" pInputText
								name="pCbs" ngModel #pCbs="ngModel"/>
						</div>

						<div class="field col-12 md:col-3" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="inscricaoMunicipal">Inscrição Municipal</label>
							<input type="number" pInputText name="inscricaoMunicipal" ngModel #inscricaoMunicipal="ngModel"/>
						</div>
						<div class="field col-12 md:col-3" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="codigoAtividade">Codigo da Atividade(CNAE)</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="codigoAtividade" ngModel #codigoAtividade="ngModel"/>
						</div>

						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="tipoRecolhimento">Tipo Recolhimento</label>
							<p-dropdown [options]="tiposTributacaoR" optionLabel="descricao"
							optionValue="id" placeholder="Selecione" emptyFilterMessage="Nenhum registro"
							name="tipoRecolhimento" ngModel #tipoRecolhimento="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-4" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="tributacao">Tributação</label>
							<p-dropdown [options]="tiposTributacaoT" optionLabel="descricao"
							optionValue="id" placeholder="Selecione" emptyFilterMessage="Nenhum registro"
							name="tributacao" ngModel #tributacaoT="ngModel" ></p-dropdown>
						</div>

						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="aliquotaIss">Alíquota ISS</label>
							<p-inputNumber suffix="%" name="aliquotaIss" ngModel #aliquotaIss="ngModel"
                                        [max]="100" [minFractionDigits]="2" [maxFractionDigits]="2" [allowEmpty]="false"
                                        [(ngModel)]="aliquotaPadrao">
                            </p-inputNumber>
						</div>

						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="ultimoNumero">Nº do Último RPS</label>
							<input type="number" pInputText name="ultimoNumero" ngModel #ultimoNumero="ngModel"
							[(ngModel)]="ultimoRps"/>
						</div>

						<div class="field col-12 md:col-5" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="urlServidorIss">URL Servidor ISS</label>
							<input type="text" pInputText
								name="urlServidorIss" ngModel #urlServidorIss="ngModel"/>
						</div>
						<div class="field col-12 md:col-3" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="cpfTomadorValido">CPF Tomador Valido</label>
							<p-inputMask mask="999.999.999-99" [unmask]="true"   type="text" placeholder="000.000.000-00"
								name="cpfTomadorValido" ngModel #cpfTomadorValido="ngModel"> </p-inputMask>
						</div>

						<div class="field col-12 md:col-2" *ngIf="tipoRegistro.value === 'RPS'">
							<label htmlFor="certificadoDigital">Certificado Digital?</label>
							<p-dropdown [options]="opcoesCertificadoDigital" optionValue="label" optionValue="value"
							name="certificadoDigital" placeholder="Selecione"
							 ngModel #certificadoDigital="ngModel" ></p-dropdown>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="button" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" (click)="voltar()"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>